import sortBy from 'lodash/sortBy'
export const sortBlocks = (blocks) => sortBy(blocks, (block) => block.title)
